import React from "react";

import { Link } from "./styles";

const PhotoDetails = () => (
    <Link href="/legal/terms-of-use/#photo-licenses" target="_blank">
        Public Domain
    </Link>
);

export default PhotoDetails;
